import { h, Component } from 'preact';
import style from './style.css';
import cx from 'classnames';

const OurOffices = () => (
	<div
		className={cx(
			style.ourOffices,
			'flex',
			'justify-center',
			'items-center',
			'flex-col'
		)}
	>
		<div className={cx('flex', 'flex-col', 'justify-center', 'items-center')}>
			<div className={'labelBoxLine'} />
			<div className={'subTitleText'}>OUR OFFICES</div>
			<Offices />
		</div>
	</div>
);

const offices = [
	{
		id: 'porto',
		name: 'PORTO',
		country: 'PORTUGAL',
		email: 'hello.pt@mindera.com',
		address: 'Porto, Portugal',
		imgUrl: '/assets/ourOffices/static_maps/porto.png',
		mapRef: 'https://goo.gl/maps/C8bt8UF8mxp'
	},
	{
		id: 'aveiro',
		name: 'AVEIRO',
		country: 'PORTUGAL',
		email: 'hello.pt@mindera.com',
		address: 'Ilhavo, Portugal',
		imgUrl: '/assets/ourOffices/static_maps/Ilhavo.png',
		mapRef: 'https://goo.gl/maps/TXJgjwJugz42'
	},
	{
		id: 'chennai',
		name: 'CHENNAI',
		country: 'CHENNAI',
		email: 'hello.in@mindera.com',
		address: 'Chennai, Tamil Nadu',
		imgUrl: '/assets/ourOffices/static_maps/india.png',
		mapRef: 'https://goo.gl/maps/s8L7npNb8Ro'
	},
	{
		id: 'leicester',
		name: 'LEICESTER',
		country: 'UNITED KINGDOM',
		email: 'hello.uk@mindera.com',
		address: 'Premier House, Leicester',
		imgUrl: '/assets/ourOffices/static_maps/leicester.png',
		mapRef: 'https://goo.gl/maps/Mceq2rZmVo22'
	},
	{
		id: 'london',
		name: 'LONDON',
		country: 'UNITED KINGDOM',
		email: 'hello.uk@mindera.com',
		address: 'Somerset House, London',
		imgUrl: '/assets/ourOffices/static_maps/london.png',
		mapRef: 'https://goo.gl/maps/bFDUnSKmFGB2'
	},
	{
		id: 'sandiego',
		name: 'SAN DIEGO',
		country: 'US',
		email: 'hello.us@mindera.com',
		address: 'San Diego, CA',
		imgUrl: '/assets/ourOffices/static_maps/san_diego.png',
		mapRef: 'https://goo.gl/maps/3pRkqacDmES2'
	}
];

class Offices extends Component {
	state = {
		selectedOffice: null
	};

	constructor(props) {
		super(props);
		this.toggle('porto');
	}

	toggle = officeId => {
		this.setState({
			selectedOffice: offices.find(office => office.id === officeId)
		});
	};

	render(props) {
		return (
			<div className={cx(style.offices, 'flex', 'flex-col')}>
				<div
					className={cx('flex', 'flex-row', 'justify-even')}
					style={{ marginBottom: '25px' }}
				>
					{offices.map(office => (
						<Office
							id={office.id}
							isSelected={this.state.selectedOffice.id === office.id}
							toggle={this.toggle}
							name={office.name}
							country={office.country}
							email={office.email}
							address={office.address}
						/>
					))}
				</div>
				<div className={'flex'}>
					<a className={'flex'} href={this.state.selectedOffice.mapRef}>
						<img className={'flex'} src={this.state.selectedOffice.imgUrl} />
					</a>
				</div>
			</div>
		);
	}
}

class Office extends Component {
	render(props) {
		return (
			<div
				className={cx(style.office, 'flex', 'flex-col', {
					[style.officeSelected]: props.isSelected
				})}
				onClick={() => props.toggle(props.id)}
			>
				<div>{props.name}</div>
				<div>{props.country}</div>
				<div>{props.email}</div>
				<div>{props.address}</div>
			</div>
		);
	}
}
export default OurOffices;



// WEBPACK FOOTER //
// ./components/OurOffices/index.jsx